/**
 * Reliable signed-in state — useSupabaseUser() alone can lag behind getSession()
 * when useSsrCookies is disabled.
 */
export function useIsAuthenticated() {
  const supabase = useSupabaseClient();
  const user = useSupabaseUser();
  const sessionActive = useState("auth:sessionActive", () => false);

  const syncSession = async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (session?.user) {
      sessionActive.value = true;
      return;
    }

    const {
      data: { user: authUser },
    } = await supabase.auth.getUser();

    sessionActive.value = Boolean(authUser);
  };

  if (import.meta.client) {
    void syncSession();
  }

  onMounted(() => {
    void syncSession();
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(() => {
      void syncSession();
    });
    onUnmounted(() => subscription.unsubscribe());
  });

  watch(user, (u) => {
    if (u) sessionActive.value = true;
  });

  const isAuthenticated = computed(
    () => Boolean(user.value) || sessionActive.value,
  );

  return { isAuthenticated, syncSession };
}
